import { getDemoStore } from './demoStore';

const routes = []; // { method, pattern, handler }
let latencyMs = 400;
let registrationPromise = null;

export function registerRoute(method, pattern, handler) {
  routes.push({ method: method.toLowerCase(), pattern, handler });
}

export function setDemoLatency(ms) { latencyMs = ms; }

export function __clearRoutesForTest() {
  routes.length = 0;
  registrationPromise = null;
}

export function registerAllDemoRoutes() {
  if (!registrationPromise) {
    registrationPromise = (async () => {
      await import('./routes/core');
      await import('./routes/campaigns');
      await import('./routes/ai');
      await import('./routes/misc');
      await import('./routes/billing');
      await import('./routes/sideEffects');
    })();
  }
  return registrationPromise;
}

const stripBase = (config) => {
  const raw = config.url || '';
  const base = config.baseURL || '';
  let path = raw.startsWith(base) ? raw.slice(base.length) : raw;
  const qIndex = path.indexOf('?');
  let query = {};
  if (qIndex !== -1) {
    query = Object.fromEntries(new URLSearchParams(path.slice(qIndex + 1)));
    path = path.slice(0, qIndex);
  }
  // Merge axios `params` if present.
  if (config.params) query = { ...query, ...config.params };
  return { path, query };
};

const parseBody = (config) => {
  if (config.data == null) return undefined;
  if (typeof config.data === 'string') {
    try { return JSON.parse(config.data); } catch { return config.data; }
  }
  return config.data;
};

const wrap = (result, config) => ({
  data: result && typeof result === 'object' && 'status' in result && 'data' in result ? result.data : result,
  status: result && typeof result === 'object' && 'status' in result ? result.status : 200,
  statusText: 'OK',
  headers: {},
  config,
});

export async function resolveDemoRequest(config) {
  await registerAllDemoRoutes();

  const method = (config.method || 'get').toLowerCase();
  const { path, query } = stripBase(config);
  const match = routes.find((r) => r.method === method && r.pattern.test(path));

  let payload;
  if (!match) {
    payload = { status: 200, data: {} };
  } else {
    const params = match.pattern.exec(path)?.groups || {};
    payload = match.handler({
      method, path, query, params,
      body: parseBody(config),
      store: getDemoStore(),
    });
  }

  if (method !== 'get' && latencyMs > 0) {
    await new Promise((resolve) => setTimeout(resolve, latencyMs));
  }
  return wrap(payload, config);
}
